module.exports = __webpack_public_path__ + "static/media/offline-icon.e9092bfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/videoShare/components/images/offline-icon.png
// module id = 1005
// module chunks = 0